var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"disabled":_vm.enableTooltip,"content":_vm.text,"placement":"top","open-delay":300}},[_c('span',{staticClass:"break-word"},[_vm._v(_vm._s(_vm.text_))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5da76a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/ketluan/break-word-span.vue
// module id = IPcA
// module chunks = 89